import React from 'react';
const Blog = () => {
    return (
        <div>
            <h2 className="m-5 text-center">Our Recent Blog</h2>
            <div class="row row-cols-1 row-cols-md-2 g-4 container-fluid">
                <div class="col">
                    <div class="card">
                        <img src="https://demo.bosathemes.com/travele/wp-content/uploads/sites/13/2021/08/img6.jpg" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title">Life is a beautiful journey not a destination</h5>
                            <p class="card-text">Praesent, risus adipisicing donec! Cras. Lobortis id aliquip taciti repudiandae porro dolore facere officia! Natoque mollitia ultrices convallis nisl suscipit</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <img src="https://demo.bosathemes.com/travele/wp-content/uploads/sites/13/2021/08/img4.jpg" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title">Take only memories, leave only footprints</h5>
                            <p class="card-text">Praesent, risus adipisicing donec! Cras. Lobortis id aliquip taciti repudiandae porro dolore facere officia! Natoque mollitia ultrices convallis nisl suscipit</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <img src="https://demo.bosathemes.com/travele/wp-content/uploads/sites/13/2021/08/img5.jpg" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title">Journeys are best measured in new friends</h5>
                            <p class="card-text">Praesent, risus adipisicing donec! Cras. Lobortis id aliquip taciti repudiandae porro dolore facere officia! Natoque mollitia ultrices convallis nisl suscipit</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <img src="https://demo.bosathemes.com/travele/wp-content/uploads/sites/13/2021/08/img1.jpg" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title">Let’s start adventure with best tripo guides</h5>
                            <p class="card-text">Praesent, risus adipisicing donec! Cras. Lobortis id aliquip taciti repudiandae porro dolore facere officia! Natoque mollitia ultrices convallis nisl suscipit</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <img src="https://demo.bosathemes.com/travele/wp-content/uploads/sites/13/2021/08/img65.jpg" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title">Enjoying the beauty of the great nature</h5>
                            <p class="card-text">Praesent, risus adipisicing donec! Cras. Lobortis id aliquip taciti repudiandae porro dolore facere officia! Natoque mollitia ultrices convallis nisl suscipit

                            </p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card">
                        <img src="https://demo.bosathemes.com/travele/wp-content/uploads/sites/13/2021/08/img3.jpg" class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title">Someday I’m going to be free and travel</h5>
                            <p class="card-text">Praesent, risus adipisicing donec! Cras. Lobortis id aliquip taciti repudiandae porro dolore facere officia! Natoque mollitia ultrices convallis nisl suscipit</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog;